import i18n from '../../language/index'
import linkData from '@/base/linkData'
export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor:{
    marginTop:'0%',
    marginLeft:'40%',
    marginRight:'40%',
    marginBottom:'0%',
    textAlign: 'center'
  },
  mb_infor:{
    marginTop:'2.666%',
    marginLeft:'30%',
    marginRight:'30%',
    marginBottom:'1.333%',
    textAlign: 'center'
  },
  pc_widgets_infor: {
    height:40,//特殊字段，只存在搜索和按钮
    borderRadius: {
      radio_val: 'default',
      default: {
        value: 4,
      },
      custom: {
        value: 4,
      }
    },
    fontStyle: {
      radio_val: 'custom',
      default: {
        lineHeight: i18n.t('view_back_top_edit_103'),
        fontSize: 30,
        fsWeight: 'normal',
        fsItalics: 'normal',
        fontStyle: '',
        fontUnderline: 'none',
        fontFamily: 'Arial',
        titleColor: 'rgba(51, 51, 51,1)',
        textAlign: 'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        lineHeight: i18n.t('view_back_top_edit_103'),
        fontSize: 30,
        fsWeight: 'normal',
        fsItalics: 'normal',
        fontStyle: '',
        fontUnderline: 'none',
        fontFamily: 'Arial',
        titleColor: 'rgba(51, 51, 51,1)',
        textAlign: 'center',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    styleType: 'type_0',
    background: {
      radio_val: 'default',
      default: {
        color: 'rgba(239,65,54,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(239,65,54,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        seColor: 'rgba(100, 100, 100,1)', // 背景设置-选中颜色
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    border: {
      radio_val: 'default',
      default: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: "rgba(0, 0, 0,1)",
        checkList: ['borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth'],
      },
      custom: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderColor: "rgba(255, 255, 255,1)",
        borderSeColor: "rgba(0, 0, 0,1)",
        checkList: ['borderTopWidth', 'borderLeftWidth'],
      }
    },
    font: {
      radio_val: 'default',
      default: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(255,255,255,1)',
        fontSeColor: 'rgba(255,255,255,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontStyle: '',
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(255,255,255,1)',
        fontSeColor: 'rgba(255,255,255,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
        sePattern: 'pure_color',
        seLinear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    }
  },
  mb_widgets_infor: {

  },
  listArr: {
    title: i18n.t('widgets_basic_article_list_edit_403'),
    link: linkData
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_button/style.js